<!-- Сегментированный переключатель разделов раскрытого ПЛАНа. -->
<template>
  <div class="plan-tabs-wrap">
    <div class="plan-tabs" role="tablist" aria-label="Разделы ПЛАНа">
      <button
        v-for="tab in tabs"
        :key="tab.value"
        class="plan-tabs__button"
        :class="{ 'plan-tabs__button--active': modelValue === tab.value }"
        type="button"
        role="tab"
        :aria-selected="modelValue === tab.value"
        @click="$emit('update:model-value', tab.value)"
      >
        <span>{{ tab.label }}</span>
        <span
          v-if="tab.badge"
          class="plan-tabs__badge"
          :class="{ 'plan-tabs__badge--changed': tab.value === 'norms' }"
        >
          {{ tab.badge }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderPlanCalculationTabs",

  props: {
    modelValue: { type: String, required: true },
    changedCount: { type: Number, default: 0 },
    historyCount: { type: Number, default: 0 },
  },

  emits: ["update:model-value"],

  computed: {
    tabs() {
      return [
        { value: "calculation", label: "Состав расчёта", badge: "" },
        {
          value: "norms",
          label: "Исходные данные",
          badge: this.changedCount ? `${this.changedCount} изменено` : "",
        },
        {
          value: "history",
          label: "История",
          badge: this.historyCount ? String(this.historyCount) : "",
        },
      ];
    },
  },
};
</script>

<style scoped>
.plan-tabs-wrap {
  padding: 10px 12px;
  border-bottom: 1px solid #e0e7ff;
  background: #f5f7ff;
}

.plan-tabs {
  display: grid;
  grid-template-columns: 1fr 1.45fr 0.8fr;
  gap: 2px;
  padding: 3px;
  border-radius: 8px;
  background: #e3e8f8;
}

.plan-tabs__button {
  min-width: 0;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 8px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #4b5068;
  font-family: inherit;
  font-size: 13px;
  cursor: pointer;
}

.plan-tabs__button--active {
  background: #fff;
  box-shadow: 0 1px 3px rgba(30, 30, 47, 0.14);
  color: #1e1e2f;
  font-weight: 600;
}

.plan-tabs__button:focus-visible {
  outline: 2px solid #3b5bdb;
  outline-offset: -2px;
}

.plan-tabs__badge {
  min-width: 18px;
  box-sizing: border-box;
  padding: 1px 6px;
  border-radius: 999px;
  background: #fff;
  color: #4b5068;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
}

.plan-tabs__badge--changed {
  background: #fef3c7;
  color: #854d0e;
}

@media (max-width: 768px) {
  .plan-tabs {
    grid-template-columns: 1fr;
  }

  .plan-tabs__button {
    justify-content: flex-start;
  }
}
</style>
